import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { defaultParseRulePriority } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class FlareDataCommentSchemaPlugin extends SchemaPlugin {

  nodes: Dictionary<NodeSpec> = {
    flaredatacomment: {
      group: 'block',
      attrs: {
        content: { default: undefined, skipExport: true }
      },
      parseDOM: [{
        tag: 'flareDataComment',
        getAttrs(dom: HTMLElement) {
          return {
            content: dom.textContent
          };
        }
      }],
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        if (options.exportForClipboard) {
          return nodeToFlareXML(node, options, null, {
            xml: `<flareDataComment>${node.attrs.content}</flareDataComment>`
          });
        } else {
          return nodeToFlareXML(node, options, null, {
            xml: `<!--${node.attrs.content}-->`
          });
        }
      },
    },
    flaredatatextcomment: {
      group: 'inline',
      inline: true,
      attrs: {
        content: { default: undefined, skipExport: true }
      },
      parseDOM: [{
        tag: 'flareDataComment',
        context: `allow_text_comment/`,
        priority: defaultParseRulePriority + 1, // This rule has a higher priority than flaredatacomment, but it is applied for nodes with 'allow_text_comment' group only.
        getAttrs(dom: HTMLElement) {
          return {
            content: dom.textContent
          };
        }
      }],
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        if (options.exportForClipboard) {
          return nodeToFlareXML(node, options, null, {
            xml: `<flareDataComment>${node.attrs.content}</flareDataComment>`
          });
        } else {
          return nodeToFlareXML(node, options, null, {
            xml: `<!--${node.attrs.content}-->`
          });
        }
      },
    },
  };
}
